<template>
    <div>
        <v-btn icon @click="addExercise">
            <v-icon color="secondary">mdi-plus</v-icon>
        </v-btn>

    </div>
</template>

<script>

export default {
    components:{
        //
    },
    methods: {
        addExercise() {
            var vm = this
            console.log(vm);
        }
    },
}
</script>